var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10.6703C1.66663 8.76323 1.66663 7.80972 2.09929 7.01928C2.53196 6.22883 3.32241 5.73825 4.90332 4.7571L6.56999 3.72272C8.24112 2.68557 9.07668 2.16699 9.99996 2.16699C10.9232 2.16699 11.7588 2.68557 13.4299 3.72272L15.0966 4.7571C16.6775 5.73825 17.468 6.22883 17.9006 7.01928C18.3333 7.80972 18.3333 8.76323 18.3333 10.6703V11.9378C18.3333 15.1885 18.3333 16.8139 17.357 17.8238C16.3807 18.8337 14.8093 18.8337 11.6666 18.8337H8.33329C5.1906 18.8337 3.61925 18.8337 2.64294 17.8238C1.66663 16.8139 1.66663 15.1885 1.66663 11.9378V10.6703Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L10 15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIco);
export default __webpack_public_path__ + "static/media/homeIco.9bb30bd17a06a9e6db5a8b9f8256af7f.svg";
export { ForwardRef as ReactComponent };